module.exports = __webpack_public_path__ + "static/media/Rohit-Chandra.06db3ca6.png";